// extracted by mini-css-extract-plugin
export default {"wrapper":"TienIch_wrapper__22AQ2","container":"TienIch_container__DFJDi","content":"TienIch_content__qajb8","image":"TienIch_image__J9+YK","info-images":"TienIch_info-images__rJU3+"};